import { render, staticRenderFns } from "./CreateChangelog.vue?vue&type=template&id=6f2fa9e7&"
import script from "./CreateChangelog.vue?vue&type=script&lang=ts&"
export * from "./CreateChangelog.vue?vue&type=script&lang=ts&"
import style0 from "./CreateChangelog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports